module.exports = __webpack_public_path__ + "img/203269c.png";